import { Tag } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";
import { __ } from "../utils";

const LearnMoreTag = ({
  url,
  style = undefined,
  label = __("Learn more")
}) => {
  const useStyle = {
    cursor: "pointer",
    ...style
  };
  return /*#__PURE__*/React.createElement(Tag, {
    style: useStyle,
    onClick: () => window.open(url, "_blank")
  }, /*#__PURE__*/React.createElement(QuestionCircleFilled, null), " ", label);
};

export { LearnMoreTag };